import React, { memo } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { ALIGN, POSITION } from 'gnos-tooltip'
import cx from 'classnames'

import ContextBurger from '../../../ContextBurger'
import Signals from '../Signals'

import './style.scss'
import Minireport from '../../../Minireport'

const Entity = ({
    entId,
    entity,
    caution,
    inactive,
    notice,
    risk,
    type,
    showBurger = true,
    value,
    rowInactive,
    showSignalsZeroValues = false,
}) => {
    const minireport = <Minireport id={entId} />

    return (
        <Tooltip
            content={minireport}
            id={`tooltip_minireport_${entId}_${Math.random()}`}
            position={POSITION.TOP}
            align={ALIGN.LEFT}
            width={'320px'}
            showDelay={1000}
            doubleWrap
        >
            <div className={'table-cell-entity'}>
                {type && <div className={`icon type-${type}${rowInactive || inactive ? '-inactive' : ''}`} />}
                <div className={cx('text', { inactive: rowInactive || inactive })}>{value}</div>
                <Signals
                    id={entId}
                    risk={risk}
                    caution={caution}
                    notice={notice}
                    showZeroValues={showSignalsZeroValues}
                />
                {showBurger && (
                    <div className={'burger-wrapper'}>
                        <ContextBurger entity={entity} id={entId} />
                    </div>
                )}
            </div>
        </Tooltip>
    )
}

Entity.propTypes = {
    caution: PropTypes.number,
    entity: PropTypes.object,
    entId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inactive: PropTypes.bool,
    notice: PropTypes.number,
    risk: PropTypes.number,
    showBurger: PropTypes.bool,
    rowInactive: PropTypes.bool,
    type: PropTypes.string,
    value: PropTypes.string,
    showSignalsZeroValues: PropTypes.bool,
}

export default memo(Entity)
